/*  MUI  */
import { ErrorOutline } from '@mui/icons-material';
import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material';

/*  React  */
import React from 'react';

export const TopInfoBanner = ({
    align = 'center',
    backgroundColor = 'topInfoBanner.defaultBackgroundColor',
    borderColor = 'topInfoBanner.defaultBorderColor',
    buttonText,
    'data-testid': dataTestid = 'topInfoBanner',
    'data-trackid': dataTrackid = 'bannerMessageInfoButton',
    displayIcon = (
        <Box>
            <ErrorOutline
                fontSize="inherit"
                sx={{
                    color: 'icon.primary'
                }}
            />
        </Box>
    ),
    externalLink,
    infoText = '',
    textColor = 'text.primary',
    title,
    titleColor = 'text.primary'
}) => (
    <Alert
        className="no-print"
        icon={displayIcon}
        severity="info"
        variant="outlined"
        sx={{
            backgroundColor,
            border: '1px solid',
            borderColor,
            justifyContent: align,
            marginBottom: '20px',
            paddingBottom: 0,
            paddingTop: 0,
            width: '100%'
        }}
    >
        <Box
            alignItems="center"
            data-testid={dataTestid}
            display="flex"
            py="4px"
        >
            <Box>
                {title && (
                    <AlertTitle>
                        <Typography
                            variant="p"
                            sx={{
                                color: titleColor,
                                fontWeight: 600
                            }}
                        >
                            {title}
                        </Typography>
                    </AlertTitle>
                )}
                <Typography
                    dangerouslySetInnerHTML={{ __html: infoText }}
                    data-testid="bannerMessageInfoText"
                    sx={{ color: textColor }}
                    variant="p"
                />
            </Box>

            {buttonText && (
                <Button
                    as="a"
                    href={externalLink}
                    target="_blank"
                    rel="noreferrer nofollow"
                    color="primary"
                    variant="contained"
                    size="small"
                    className="link--white"
                    style={{ marginLeft: '8px', minWidth: '128px' }}
                    data-trackid={dataTrackid}
                >
                    {buttonText}
                </Button>
            )}
        </Box>
    </Alert>
);

export default TopInfoBanner;
